<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  version="1.1"
  style="position: fixed; width: 0; height: 0"
>
  <style>
    use {
      fill-opacity: 1;
      fill: currentColor;
    }
  </style>

  <symbol id="checkmark-icon" viewBox="0 0 15 15">
    <path d="M0 0h15v15H0z" fill="none"></path>
    <path
      d="M5.829 11.364a.997.997 0 0 1-.707-.293l-2.83-2.828A1 1 0 0 1 3.708 6.83l2.121 2.12 5.657-5.657a.999.999 0 1 1 1.413 1.414l-6.363 6.364a.997.997 0 0 1-.707.293z"
    ></path>
  </symbol>
</svg>

<i2g-icon class="checkmark" [icon]="checkmarkIcon"> </i2g-icon>
